module.exports = __webpack_public_path__ + "static/img/security-logos.b56167c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onboarding/security-logos.png
// module id = MVxt
// module chunks = 6